import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CONTACT_EMAIL_EDIT_FORM_SCHEMA = yup.object().shape({
  emailAddress: yup.string().email().required('Molimo Vas da unesete email'),
});

